import React, { createContext, useContext, useMemo, useState } from 'react';

const HeaderActionsContext = createContext(null);

export const HeaderActionsProvider = ({ children }) => {
  const [leftSlot, setLeftSlot] = useState(null);

  const value = useMemo(() => ({ leftSlot, setLeftSlot }), [leftSlot]);

  return (
    <HeaderActionsContext.Provider value={value}>
      {children}
    </HeaderActionsContext.Provider>
  );
};

export const useHeaderActions = () => {
  const ctx = useContext(HeaderActionsContext);
  if (!ctx) {
    throw new Error('useHeaderActions must be used within a HeaderActionsProvider');
  }
  return ctx;
};
